// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buttons {\n  margin-top: 20px;\n}\n.terms {\n  list-style-type: disc;\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
